import { useEffect, useState } from 'react'
import { api } from '../utils/api'
import { useAuthStore } from '../stores/authStore'

export interface CostData {
  enabled: boolean
  today?: { total: number; limit: number; percentage: number }
  month?: { total: number; limit: number; percentage: number }
}

// Owns the cost-dashboard poll (every 60s) + data/loading state. The consuming
// widget keeps only presentation. Behaviour mirrors the previous in-component
// logic exactly (admin-only, 60s interval, cancelled guard).
export function useCost() {
  const { token, csrfToken, role } = useAuthStore()
  const [data, setData] = useState<CostData | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!token || role !== 'admin') return

    let cancelled = false
    const fetchCost = async () => {
      try {
        const res = await api.get<CostData>('/api/cost/dashboard', token, csrfToken || undefined)
        if (cancelled) return
        if (res.success && res.data) {
          setData(res.data)
        }
      } catch {
        // Silent — admin-only widget, don't spam toasts on transient errors
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    fetchCost()
    const timer = setInterval(fetchCost, 60_000)
    return () => { cancelled = true; clearInterval(timer) }
  }, [token, csrfToken, role])

  return { data, loading, role }
}
